<template>
  <div class="d-flex">
    <div class="side-frame-warning"></div>
    <div>
      <span style="font-size: 14px; color: #606266">
        {{ $l('table_label_cutting_size') || '开料尺寸' }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-success"
        @click="$emit('openDetailDialog', { type: 'add' })"
        :disabled="disabled"
      >
        {{ $l('INDEX.btn_add') || '添加' }}
      </b-button>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-danger"
        @click="$emit('batchDel')"
        :disabled="disabled"
      >
        {{ this.$l('INDEX.btn_delete') || '删除' }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } }
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 5px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 5px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 5px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 5px;
}
</style>
